module.exports = __webpack_public_path__ + "img/p60-1994-chuangkan.5a12ec6d.jpg";